/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useContext, useState } from "react";
import { TextField } from "@mui/material";
import { EntityContext } from "cms/entity/context";

const TextEntityAttributeEditor = (props) => {
    
    const name = props.name;
    const value = props.value;
    
    const [text, setText] = useState(value);
    
    const entityContext = useContext(EntityContext);
    const updateAttribute = entityContext?.updateAttribute;

    const onChange = (event) => {
        const _text = event.target.value;
        setText(_text);
        updateAttribute(name, _text);
    };
    
    return (
        <Fragment>
            <div className="entity-attribute-editor-label">
                {name}
            </div>
            <div className="entity-attribute-editor-panel">
                <TextField
                    fullWidth={true}
                    defaultValue={text}
                    variant="outlined"
                    onChange={onChange}
                />
            </div>
        </Fragment>
    );
};

export { TextEntityAttributeEditor };
